module.exports = __webpack_public_path__ + "img/solar-panels.56eddf05.jpg";